import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { DelegationChkbox, FormSubTitle,FormSubTitleDesp,FormTitle } from '../validation/Form-Components';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import TooltipTemplate from '../components/TooltipTemplate';
import { Tooltip } from '@progress/kendo-react-tooltip';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import delegateData from '../data/delegationdetailsdata.json';
import condOfSignArray from '../data/condofsign.json';
import service from '../services/ApiService.js';
import CusRadioButton from '../components/CusRadioButton';
import Loading from '../components/Loading';
import CusNotification from '../components/CusNotification';
import designations from '../data/position.json';
import helper from '../factory/Helper';
import WtBgChkbox from '../components/WtBgChkbox';
import CusToast from '../components/CusToast';

// let user = {"value":'', "label": ''};
// let designation = '';

const DelegationDetails = (props) => {

    let timer;
    const detailsType='5';
    const boardResoType='9';
    const item = { bgcolor: "#389A6E", completed: 60 };
    const history = useHistory();
    const [condOfSign, setCondOfSign] = useState({});
    const [authPersonChecked, setAuthPersonChecked] = useState(true);
    const [authSignChecked, setAuthSignChecked] = useState(true);
    const [benefitOwnerChecked, setBenefitOwnerChecked] = useState(true);
    const [rdoCheckedValue, setRdoCheckedValue] = useState();
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);
    const [user, setUser] = useState({"value":'', "label": ''});
    const [designation,setDesignation] = useState('');

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [initFormData, setInitFormData] = useState({BoadResoClare:false});

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        window.scrollTo(0,0);
        setCondOfSign(condOfSignArray[0]);  //set default Singly for Sole props
        getData();

        return () => clearTimeout(timer);
    }, []);

 
    const getData = () => {

        service.get().then( res =>{
   
            if(res.data.isSucess){
                bindBoadResoClare(res.data.model.fields.request)
                bindFormData(res.data.model.fields.request);
                setIsLoading(false);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
         
            setIsLoading(false);
        })
    }

    const bindFormData = (data) => {
        const myInfoData = data.ApplicantsDtlsMyInfo;
        try {
            if(data) {
                let userObj = {"value":data.ApplicantDtls.IDNum? data.ApplicantDtls.IDNum : '', "label":data.ApplicantDtls.Name? data.ApplicantDtls.Name: ''};
                setUser(userObj);
                let designt =  !myInfoData.Designation? '': myInfoData.Designation ;
                setDesignation(designt);
 
                setRdoCheckedValue(data.IsAboveABeneficialOwner? data.IsAboveABeneficialOwner !== null? data.IsAboveABeneficialOwner:'':'');
            }
        } catch(ex) {
           
        }
    }

    const bindBoadResoClare = (data) => {
  
        if(data.BoadResoClare !== undefined) {
            setInitFormData({BoadResoClare:data.BoadResoClare === 'true'? true:false})
        }
        else {
            setInitFormData({BoadResoClare:false})
        }
    }

    const handleSubmit = (eve) =>{
        
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        if(rdoCheckedValue === '' || rdoCheckedValue === null || rdoCheckedValue === undefined){
            showErrMsg(config.error.DelegationDetails.IsAboveABeneficialOwner);
            return;
        }
 
        let params1 = formatDeleJsonParams();
        if(params1.AuthSign.IDNum === '' || params1.AuthSign.IDNum === null || params1.AuthSign.IDNum === undefined){
            showErrMsg(config.error.SaveApiFailed);
            return;
        }

        let params2 = formatBoardResoJsonParams();
        if(params2.ApptAuthPerson.IDNum === '' || params2.ApptAuthPerson.IDNum === null || params2.ApptAuthPerson.IDNum === undefined) {
            showErrMsg(config.error.SaveApiFailed);
            return;
        }

        saveDeleDetails(params1);
    }

    const saveDeleDetails = (params) =>{
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                service.post(boardResoType,formatBoardResoJsonParams())
                .then(bres=>{
                    if(bres.data.isSucess) {
                        goNext();
                    }
                    else {
                        showErrMsg(config.error.SaveApiFailed);
                    }
                })
                .catch(berr => {
                    showErrMsg(config.error.SaveApiFailed);
                })
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }    
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.TaxDetails);
        }
    }
 
    let formatDeleJsonParams = function() {
        let params = {
            ASBOConOfSign:null,  
            AuthSign:{
                IDNum:user.value,
                Name:user.label,
                Designation:designation,
                SelectedValue:true
            },
            BenificialOwner:{
                IDNum:user.value,
                Name:user.label,
                Designation:designation,
                SelectedValue:true
            },
            IsAboveABeneficialOwner:rdoCheckedValue
        }
        return params;
    }
    
    let formatBoardResoJsonParams = function() {
        let params = {
            SignConditionAP:condOfSignArray[0].value,   
            ApptAuthPerson:{
                IDNum:user.value,
                Name:user.label,
                Designation:designation,
                SelectedValue:true
            },
            BoardResolutions:{
                CertifyPerson:null
            },
            BoadResoClare: true  
        }
 
        return params;
    }

    const onRdoHandleChange = React.useCallback( (e) =>{
         setRdoCheckedValue(e.value);
    },[setRdoCheckedValue])
 

    const onAuthPersonChkboxChange = (e) => {
     
        setAuthPersonChecked(e.value);
    }
    
    const onAuthSignChkboxChange = (e) => {
  
        setAuthSignChecked(e.value);
    }

    const onBenefitOwnerChkboxChange = (e) => {
        setBenefitOwnerChecked(e.value);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const getDesignationLabel = (code) => {
        if(code !== undefined && code !==null && code !== '') {
            return helper.getObjInArray(code,designations).label;
        }
        return '';
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader />
            <FormContainer>
                <Form  
                    onSubmitClick={handleSubmit} 
                    initialValues={initFormData}
                    render={(formRenderProps) => (
                    <FormElement>
                    <fieldset>
                        <Field component={FormTitle} id={'fst1'} name={delegateData.formContainerTitle.T1.name} />
                        
                    <FieldWrapper>
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="box" id={'lblConOfSign'}  style={{ marginTop: "5px" }}>
                                    <div style={{width:'94%', float:"left"}}><span>{delegateData.label.conOfSign}</span></div>
                                </div>
                                <div style={{width:'6%', float:"left"}}>
                                    <Tooltip id={'ttConOfSign'} content={(props) => 
                                    <TooltipTemplate id={'tttConOfSign'} title={props.title}/>} 
                                        anchorElement={'target'} position={'right'} >
                                        <span className="k-icon k-i-information" title={delegateData.tooltip.conOfSign}></span> 
                                    </Tooltip>
                                </div>
                            </div>
                          
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="box" style={{ marginTop: "7px" }}>
                                    <ComboBox
                                        id="condOfSignCbo" name="condOfSignCbo"
                                        clearButton={false}
                                        data={condOfSignArray}
                                        textField="label"
                                        dataItemKey="value"
                                        disabled={true}
                                        value={condOfSign}/>
                                </div>
                            </div>
                        </div>
                        </FieldWrapper>
                           
                        <Field component={FormSubTitle} id={'fstST1'} name={delegateData.formSubTitle.ST1} />
                                    
                        <Field component={FormSubTitleDesp} id={'fstSTD1'} name={delegateData.formSubTitleDesp.STD1}  />
 
                        <WtBgChkbox id={'chkAuthPer'} label={user.label} rightLabel={getDesignationLabel(designation)}
                            checkedValue={true} disabled={true} />
                        
                         <Field component={FormSubTitle} id={'fstST2'} 
                                    name={delegateData.formSubTitle.ST2}   />
                                    
                        <Field component={FormSubTitleDesp} id={'fstSTD2'} 
                                    name={delegateData.formSubTitleDesp.STD2}  />

                        <WtBgChkbox id={'chkAuthSign'} label={user.label} rightLabel={getDesignationLabel(designation)}
                            checkedValue={true} disabled={true} />

                        <Field component={FormSubTitle} id={'fstST3'} 
                                    name={delegateData.formSubTitle.ST3} />
                                    
                        <Field component={FormSubTitleDesp} id={'fstSTD3'} 
                                    name={delegateData.formSubTitleDesp.STD3Sole} />

                        <Field component={FormSubTitle} id={'fstST3'} 
                                    name={delegateData.label.beneOwner} />

                        <WtBgChkbox id={'chkBenetOwner'} label={user.label} rightLabel={getDesignationLabel(designation)}
                            checkedValue={true} disabled={true} />

                    <FieldWrapper>
                        <CusRadioButton name="rdoBeneOwner" leftValue='Y' rightValue='N' disabled={false}
                            label={delegateData.label.rdoSoleBeneOwner} onChange={onRdoHandleChange} checkedValue={rdoCheckedValue} />
                    </FieldWrapper>

                    <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} /> 

                    <div className="row around-xs inputPair elementVisible" style={{ paddingBottom: "20px" }}>
                        <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <button className="btn btn-back" onClick={() => { history.push(config.route.BizBankingService)}}>{config.btnName.Back}</button>
                            <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                        </div>
                    </div> 

                    {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                            onClose={()=>{ setIsError(false)}} />} */}
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}/> 
                      </fieldset>
                    </FormElement>
                )}>
                </Form>
            </FormContainer>
            {isSaving && <Loading />} 
        </div>
    )
}

export default DelegationDetails